<template>
  <div class="form-row">
    <form :class="{ 'loading-opacity': preloader, 'col-sm-12 p-4': isAdmin, 'mb-0 ml-sm-4 col-md-12': !isAdmin }">
      <div class="form-group">
        <h5 class="text-center mb-0">
          Address Information
        </h5>
        <div v-if="gaps.length > 0" class="gap-warning mt-4">
          <h4 class="text-danger">⚠ Address Gaps Found</h4>
          <ul class="text-danger">
            <li v-for="(gap, index) in gaps" :key="index">
              Missing period: {{ dateFormatter(gap.start) }} to {{ dateFormatter(gap.end) }}
            </li>
          </ul>
        </div>

        <!-- Warning if history is less than 5 years -->
        <div v-if="!isFiveYearsCovered" class="text-danger mt-3">
          <strong>⚠ Address history must cover the last 5 years.</strong>
        </div>
      </div>
      <div class="d-flex flex-wrap justify-content-between">
        <div class="col-md-6 my-2" v-for="(item, index) in address_Info" :key="index">
            <div class="card-item">
              <div class="form-group row align-items-center">
                <label class="col-sm-12 mb-sm-1 current-address"
                       v-if="index === 0">Current Address</label>
                <div class="col-6">
                  <label class="col-sm-12 mb-sm-1">Address No. {{ index + 1 }}</label>
                  <label class="col-sm-12 mb-sm-1">{{ item.address }}</label>
                  <label class="col-sm-12 mb-sm-1">City: {{ item.city }} | Post Code {{ item.post_code }}</label>
                  <label class="col-sm-12 mb-sm-1">{{ dateFormatter(item.from_date) }} /
                    {{ index === 0 ? 'Till Date' : dateFormatter(item.to_date) }}</label>

              </div>
                <div class="col-6" v-if="isAdmin">
                    <div v-if="item.screening_endorsement">
                      Endorsements
                      <p><strong>Requested At:</strong> {{ item.screening_endorsement.requested_at }}</p>
                      <p v-if="item.screening_endorsement.endorsed_at">
                        <strong>Endorsed At:</strong> {{ item.screening_endorsement.endorsed_at }}
                      </p>
                      <p><strong>Status:</strong> {{ item.screening_endorsement.status }}</p>
                    </div>
                  <div v-if="getLatestStatus(item)"
                       :class="getHighlightClass(getLatestStatus(item))"
                       :style="getHighlightStyle(getLatestStatus(item))"
                  >
                    {{ getStatusValue(getLatestStatus(item)) }}
                  </div>

                  <div v-if="!getLatestStatus(item)"
                       class="highlight-orange"
                  >Verification Pending
                  </div>

                  </div>
                <div class="col-6">
                  <div
                      v-if="!isAdmin && isRevertToApplicant(getLatestStatus(item))"
                      class="highlight-orange"
                  >To do: {{  getStatusComment(getLatestStatus(item)) }}
                  </div>
                </div>
                <div class="col-sm-12 mt-sm-3 d-flex flex-wrap">
                  <el-button class="btn btn-danger el-button--default float-right"
                             @click="openFormInModal(index)">
                    Update
                  </el-button>
                  <el-button class="btn btn-danger el-button--default float-right mr-sm-2"
                             :disabled="(index === address_Info.length) ? true : false"
                             @click="removeBtnHandler(index)">
                    Remove
                  </el-button>
                  <div class="col-md-4 mr-sm-2" v-if="isAdmin">
                    <drawer-component title="Comments" size="80%" btnText="Take Action">
                      <address-comments
                          :comment="item.screening_status"
                          :applicantId="candidateId"
                          :statusable_type="item.statusable_type"
                          :statusable_id="item.id"
                          :address="item"
                          :emailAddress="emailAddress"
                      />
                    </drawer-component>
                  </div>
                </div>
                </div>

              </div>

          </div>
        </div>
      <div class="col-6">
        <div class="form-group row align-items-center">
          <label class="h2 col-sm-12">
            {{ address_count === 0 ? 'Add Current Address' : 'Add Previous Address' }}
          </label>
        </div>

        <!-- Search for an address -->
        <!--        <div class="form-group row align-items-center">-->
        <!--          <label class="col-sm-2 mb-sm-0">Search by post code</label>-->
        <!--          <app-input class="col-sm-8 mb-sm-2"-->
        <!--                     type="post-code"-->
        <!--                     v-model="addressObj.post_code"-->
        <!--                     @postal-code-found="updateAddressCoordinates"-->
        <!--                     placeholder="Start typing your postal code ..."/>-->
        <!--        </div>-->

        <!-- Street -->
        <div class="form-group row align-items-center">
          <label class="col-sm-2 mb-sm-0">Door No.</label>

          <app-input
              type="text"
              v-model="addressObj.door_number"
              placeholder="Door No."
              @blur="$v.addressObj.door_number.$touch()"
          />
          <div class="error" v-if="$v.addressObj.door_number.$error">
            {{ $t('field_is_required') }}
          </div>
        </div>
        <div class="form-group row align-items-center">
          <label class="col-sm-2 mb-sm-0">Street</label>

          <app-input
              type="text"
              v-model="addressObj.street"
              placeholder="Street"
              @blur="$v.addressObj.street.$touch()"
          />
          <div class="error" v-if="$v.addressObj.street.$error">
            {{ $t('field_is_required') }}
          </div>
        </div>

        <!-- Town or city -->
        <div class="form-group row align-items-center">
          <label class="col-sm-2 mb-sm-0">City</label>

          <app-input
              type="text"
              v-model="addressObj.city"
              placeholder="Town or city"
              @blur="$v.addressObj.city.$touch()"
          />
          <div class="error" v-if="$v.addressObj.city.$error">
            {{ $t('field_is_required') }}
          </div>
        </div>

        <!-- County -->
        <div class="form-group row align-items-center">
          <label class="col-sm-2 mb-sm-0">County</label>

          <app-input
              type="text"
              v-model="addressObj.county"
              placeholder="County"
              @blur="$v.addressObj.county.$touch()"
          />
          <div class="error" v-if="$v.addressObj.county.$error">
            {{ $t('field_is_required') }}
          </div>
        </div>

        <!-- Postcode -->
        <div class="form-group row align-items-center">
          <label class="col-sm-2 mb-sm-0">Post Code</label>

          <app-input
              type="text"
              v-model="addressObj.post_code"
              placeholder="Postcode"
              @blur="$v.addressObj.post_code.$touch()"
          />
          <div class="error" v-if="$v.addressObj.post_code.$error">
            {{ $t('field_is_required') }}
          </div>
        </div>

        <!-- Country -->
        <div class="form-group row align-items-center">
          <label class="col-sm-2 mb-sm-0">Country:</label>

          <app-input
              type="text"
              v-model="addressObj.country"
              placeholder="Country"
              @blur="$v.addressObj.country.$touch()"
          />
          <div class="error" v-if="$v.addressObj.country.$error">
            {{ $t('field_is_required') }}
          </div>
        </div>


        <div class="form-group row align-items-center">
          <label class="col-sm-2 mb-sm-0">From Date</label>
          <app-input
              type="date"
              v-on:blur="$v.addressObj.from_date.$touch()"
              v-model="addressObj.from_date"
              placeholder=""/>
          <div class="error col-sm-2" v-if="!$v.addressObj.from_date.required">
            {{ $t('field_is_required') }}
          </div>
          <div class="error col-sm-12" v-if="!$v.addressObj.from_date.isValidFromDate">
            {{ $t('from_date_compare_to_date') }}
          </div>
        </div>
        <div class="form-group row align-items-center">
          <label class="col-sm-2 mb-sm-0">To Date</label>
          <app-input
              type="date"
              v-model="addressObj.to_date"
              v-on:blur="$v.addressObj.to_date.$touch()"
              :read-only="false"
              :disabled="false"/>
          <div class="error col-sm-2" v-if="$v.addressObj.to_date.$error">
            {{ $t('field_is_required') }}
          </div>
        </div>

        <div class="form-group row align-items-center">
          <div class="col-sm-12">
            <el-button class="btn el-button--success"
                       @click="addBtnHandler()">
              Save & Add New
            </el-button>
          </div>
        </div>
        <div class="form-group row align-items-center">
          <h6 class="text-center mb-0">
            {{ $t('five_years_error') }}
          </h6>
        </div>
      </div>

      <template v-if="is_modal">
        <app-modal :modal-id="modalId"
                   modal-alignment="top"
                   modal-size="fullscreen"
                   @close-modal="closeModal">
          <template slot="header">
            <h5 class="modal-title">{{ $t("Update Address") }}</h5>
            <button type="button"
                    class="close outline-none"
                    data-dismiss="modal"
                    aria-label="Close">
            <span>
              <app-icon :name="'x'"></app-icon>
            </span>
            </button>
          </template>
          <template slot="body">
            <div class="card card-with-search border-0 card-with-shadow">
              <div class="form-group row align-items-center">
                <label class="col-sm-2 mb-sm-0">Door No.</label>

                <app-input
                    type="text"
                    v-model="addressObj.door_number"
                    placeholder="Door No."
                    @blur="$v.addressObj.door_number.$touch()"
                />
                <div class="error" v-if="$v.addressObj.door_number.$error">
                  {{ $t('field_is_required') }}
                </div>
              </div>
              <div class="form-group row align-items-center">
                <label class="col-sm-2 mb-sm-0">Street</label>

                <app-input
                    type="text"
                    v-model="addressObj.street"
                    placeholder="Street"
                    @blur="$v.addressObj.street.$touch()"
                />
                <div class="error" v-if="$v.addressObj.street.$error">
                  {{ $t('field_is_required') }}
                </div>
              </div>

              <!-- Town or city -->
              <div class="form-group row align-items-center">
                <label class="col-sm-2 mb-sm-0">City</label>

                <app-input
                    type="text"
                    v-model="addressObj.city"
                    placeholder="Town or city"
                    @blur="$v.addressObj.city.$touch()"
                />
                <div class="error" v-if="$v.addressObj.city.$error">
                  {{ $t('field_is_required') }}
                </div>
              </div>

              <!-- County -->
              <div class="form-group row align-items-center">
                <label class="col-sm-2 mb-sm-0">County</label>

                <app-input
                    type="text"
                    v-model="addressObj.county"
                    placeholder="County"
                    @blur="$v.addressObj.county.$touch()"
                />
                <div class="error" v-if="$v.addressObj.county.$error">
                  {{ $t('field_is_required') }}
                </div>
              </div>

              <!-- Postcode -->
              <div class="form-group row align-items-center">
                <label class="col-sm-2 mb-sm-0">Post Code</label>

                <app-input
                    type="text"
                    v-model="addressObj.post_code"
                    placeholder="Postcode"
                    @blur="$v.addressObj.post_code.$touch()"
                />
                <div class="error" v-if="$v.addressObj.post_code.$error">
                  {{ $t('field_is_required') }}
                </div>
              </div>

              <!-- Country -->
              <div class="form-group row align-items-center">
                <label class="col-sm-2 mb-sm-0">Country:</label>

                <app-input
                    type="text"
                    v-model="addressObj.country"
                    placeholder="Country"
                    @blur="$v.addressObj.country.$touch()"
                />
                <div class="error" v-if="$v.addressObj.country.$error">
                  {{ $t('field_is_required') }}
                </div>
              </div>


              <div class="form-group row align-items-center">
                <label class="col-sm-2 mb-sm-0">From Date</label>
                <app-input
                    type="date"
                    v-on:blur="$v.addressObj.from_date.$touch()"
                    v-model="addressObj.from_date"
                    placeholder=""/>
                <div class="error col-sm-2" v-if="!$v.addressObj.from_date.required">
                  {{ $t('field_is_required') }}
                </div>
                <div class="error col-sm-12" v-if="!$v.addressObj.from_date.isValidFromDate">
                  {{ $t('from_date_compare_to_date') }}
                </div>
              </div>
              <div class="form-group row align-items-center">
                <label class="col-sm-2 mb-sm-0">To Date</label>
                <app-input
                    type="date"
                    v-model="addressObj.to_date"
                    v-on:blur="$v.addressObj.to_date.$touch()"
                    :read-only="false"
                    :disabled="false"/>
                <div class="error col-sm-2" v-if="$v.addressObj.to_date.$error">
                  {{ $t('field_is_required') }}
                </div>
              </div>
            </div>
          </template>
          <template slot="footer">
            <button type="button"
                    class="btn btn-secondary mr-2"
                    data-dismiss="modal"
                    @click="updateForm">
              {{ (update_index === 0 && address_Info.length > 1) ? 'Edit Current Address' : $t("Edit") }}
            </button>
            <button type="button"
                    class="btn btn-primary mr-2"
                    data-dismiss="modal"
                    @click="closeModal">
              {{ $t("Close") }}
            </button>
          </template>
        </app-modal>
      </template>
    </form>
  </div>
</template>

<script>
import {ModalMixin} from "../../../../../../app/Mixins/ModalMixin";
import {required, minLength} from 'vuelidate/lib/validators'
import {FormMixin} from "@/core/mixins/form/FormMixin";
import {
  getHighlightClass,
  getHighlightStyle,
  getLatestStatus,
  getStatusComment,
  getStatusValue,
  isRevertToApplicant
} from "@Views/Screening/utility/common";
import {_statusColors} from "@Views/Screening/utility/constant";

export default {
  name: "AddressInfo",
  mixins: [FormMixin, ModalMixin],
  props: {
    yesOrNoList: {
      type: Array
    },
    address_Info: {
      type: Array,
      required: true
    },
    dateFormatter: {
      type: Function,
      required: true
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    candidateId: {
      type: Number,
    },
    emailAddress: {
      type: String
    },
    onSaveBtn: Function,
  },
  mounted() {
    this.setToDate();
  },
  data() {
    return {
      addressObj: {
        'city': '',
        'country': '',
        'door_number': '',
        'from_date': '',
        'post_code': '',
        'street': '',
        'to_date': '',
        'county': '',
      },
      is_modal: false,
      update_index: 0,
      modalId: "address_modal",
      statusColors: _statusColors,
    };
  },
  watch:{
  },
  methods: {
    getHighlightStyle,
    getStatusComment,
    getLatestStatus,
    getStatusValue,
    isRevertToApplicant,
    getHighlightClass,
    addBtnHandler() {
      if (!this.$v.$invalid) {
        const to_date = this.addressObj.from_date;
        this.address_Info.push(this.addressObj);
        this.addressObj = {};
        this.addressObj.to_date = to_date;

        try {
          this.onSaveBtn()
        } catch (e) {
          console.error(e)
        }
      }
    },

    openFormInModal(index) {
      this.addressObj = this.address_Info[index];
      this.update_index = index;
      this.is_modal = true;
    },
    removeBtnHandler(index) {
      if (this.address_Info.length > 0) {
        this.address_Info.splice(index, 1);
      }
      this.setToDate();
    },
    updateForm() {
      if (!this.$v.$invalid) {
        this.address_Info[this.update_index] = this.addressObj;
        this.is_modal = false;
      }
    },
    updateAddressCoordinates(addressObjPassed){
      this.addressObj.street = addressObjPassed.lsoa
      this.addressObj.city = addressObjPassed.admin_district
      this.addressObj.county = addressObjPassed.admin_county??`-`
      this.addressObj.post_code = addressObjPassed.postcode
      this.addressObj.country = addressObjPassed.country
    },
    setToDate() {
      const toDate = (this.address_Info.length > 0) ? this.address_Info[this.address_Info.length - 1].to_date : new Date();
      this.$set(this.addressObj, 'to_date', toDate);
    },
    closeModal() {
      this.addressObj = {};
      this.$emit('close-modal');
      this.is_modal = false;
    },
  },
  computed: {
    address_count(){
     return this.address_Info.length ?? 0
    },
    sortedAddresses() {
      // Sort addresses from most recent to oldest
      return [...this.address_Info].sort((a, b) => new Date(b.from_date) - new Date(a.from_date));
    },
    gaps() {
      let gaps = [];
      const fiveYearsAgo = new Date();
      fiveYearsAgo.setFullYear(fiveYearsAgo.getFullYear() - 5);

      let today = new Date();
      let gracePeriodDate = new Date();
      gracePeriodDate.setDate(gracePeriodDate.getDate() - 40); // 40-day grace period

      // Sort addresses by from_date (earliest first)
      let sortedAddresses = [...this.sortedAddresses].sort(
          (a, b) => new Date(a.from_date) - new Date(b.from_date)
      );

      let previousToDate = today; // Start from today

      // 🔥 **Detect initial gap from 5 years ago to first address**
      if (sortedAddresses.length === 0 || new Date(sortedAddresses[0].from_date) > fiveYearsAgo) {
        gaps.push({
          start: fiveYearsAgo,
          end: sortedAddresses.length > 0 ? new Date(sortedAddresses[0].from_date) : today,
        });
      }

      sortedAddresses.forEach((address, index) => {
        const currentFromDate = new Date(address.from_date);
        const currentToDate = address.to_date ? new Date(address.to_date) : today;

        // Apply 40-day grace period for the most recent address
        if (index === 0 && currentToDate >= gracePeriodDate) {
          previousToDate = today;
        }

        // Ignore addresses before 5 years ago
        if (currentFromDate < fiveYearsAgo) return;

        // 🔥 **Detect gaps between addresses**
        if (currentFromDate > previousToDate) {
          gaps.push({
            start: previousToDate,
            end: currentFromDate,
          });
        }

        // Update previousToDate to the latest known "to_date"
        previousToDate = currentToDate > previousToDate ? currentToDate : previousToDate;
      });

      return gaps;
    }


    ,
    isFiveYearsCovered() {
      if (!this.sortedAddresses.length) return false;

      const currentDate = new Date();
      const fiveYearsAgo = new Date();
      fiveYearsAgo.setFullYear(currentDate.getFullYear() - 5);

      const oldestAddressDate = new Date(this.sortedAddresses[this.sortedAddresses.length - 1].from_date);

      return oldestAddressDate <= fiveYearsAgo;
    },
  },
  validations: {
    addressObj: {
      door_number: {
        required
      },
      city: {
        required
      },
      post_code: {
        required
      },
      country: {
        required
      },
      county: {
        required
      },
      street: {
        required
      },
      from_date: {
        required,
        isValidFromDate(value) {
          if (value && (value < new Date(this.addressObj.to_date))) {
            return true;
          }
          return false;
        }
      },
      to_date: {
        required
      }
    }
  }
};
</script>

<style>
.error {
  color: red;
  font-weight: bold;
}

.card-item {
  min-height: 150px;
  background: #ececec;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 0 20px #ececec;
}

.current-address {
  position: absolute;
  content: '';
  top: 0px;
  right: 15px;
  width: 100px;
  background: #2b303b;
  color: #ffffff !important;
  padding: 5px;
  border-radius: 0 5px 0 0;
}
</style>